// extracted by mini-css-extract-plugin
export default {"container_info":"Info_container_info__eXZrY"};